(function () {
	"use strict";

	// Wait for DOM to be ready
	document.addEventListener("DOMContentLoaded", function () {
		const queryPostsBlock = document.querySelector(".wp-block-query-posts");
		if (!queryPostsBlock) return;

		// Get elements
		const categorySelect = document.getElementById(
			"query-posts-category-filter",
		);
		const subcategorySelect = document.getElementById(
			"query-posts-subcategory-filter",
		);
		const postsGrid = document.querySelector(".posts-grid");
		const loadingIndicator = document.querySelector(".query-posts-loading");
		const resultsCount = document.querySelector(".query-posts-count");
		const currentCountSpan = document.querySelector(".posts-count-current");
		const totalCountSpan = document.querySelector(".posts-count-total");
		const paginationContainer = document.querySelector(
			".query-posts-pagination",
		);
		const resetButton = document.getElementById("query-posts-reset-button");

		// Get data attributes
		const apiUrl = queryPostsBlock.getAttribute("data-api-url");
		const selectedCategory = queryPostsBlock.getAttribute(
			"data-selected-category",
		);
		const postsPerPage = parseInt(
			queryPostsBlock.getAttribute("data-posts-per-page"),
			10,
		);
		const columns = parseInt(queryPostsBlock.getAttribute("data-columns"), 10);

		// Get subcategories data
		const subcategoriesDataElement = document.getElementById(
			"query-posts-subcategories-data",
		);
		const subcategoriesData = subcategoriesDataElement
			? JSON.parse(subcategoriesDataElement.textContent)
			: [];

		// Current filter state
		let currentFilters = {
			category: selectedCategory || "",
			subcategory: "",
			page: 1,
			per_page: postsPerPage,
		};

		// Show loading state
		function showLoading() {
			if (loadingIndicator) loadingIndicator.style.display = "flex";
			if (postsGrid) postsGrid.style.opacity = "0.5";
		}

		// Hide loading state
		function hideLoading() {
			if (loadingIndicator) loadingIndicator.style.display = "none";
			if (postsGrid) postsGrid.style.opacity = "1";
		}

		// Enable/disable reset button based on active filters
		function updateResetButtonState() {
			const hasActiveFilters =
				currentFilters.category || currentFilters.subcategory;
			if (resetButton) {
				resetButton.disabled = !hasActiveFilters;
			}
		}

		// Reset all filters
		function resetFilters() {
			// Clear all filter values
			currentFilters.category = selectedCategory || "";
			currentFilters.subcategory = "";
			currentFilters.page = 1;

			// Reset UI elements
			if (categorySelect) categorySelect.value = "";
			if (subcategorySelect) {
				subcategorySelect.value = "";
				subcategorySelect.disabled = true;
				// Reset to placeholder
				const placeholderOption =
					subcategorySelect.querySelector('option[value=""]');
				if (placeholderOption) {
					placeholderOption.textContent = "Select a category first";
				}
			}

			// Disable reset button
			updateResetButtonState();

			// Fetch posts with cleared filters (no scroll)
			fetchPosts(false);
		}

		// Build query string from filters
		function buildQueryString() {
			const params = new URLSearchParams();
			if (currentFilters.category)
				params.append("category", currentFilters.category);
			if (currentFilters.subcategory)
				params.append("subcategory", currentFilters.subcategory);
			params.append("page", currentFilters.page);
			params.append("per_page", currentFilters.per_page);
			return params.toString();
		}

		// Escape HTML to prevent XSS
		function escapeHtml(text) {
			if (!text) return "";
			const div = document.createElement("div");
			div.textContent = text;
			return div.innerHTML;
		}

		// Fetch posts from API
		async function fetchPosts(shouldScroll = true) {
			// Scroll to filters before fetching if requested
			if (shouldScroll) {
				const filtersElement = document.querySelector(".query-posts-filters");
				if (filtersElement) {
					filtersElement.scrollIntoView({ behavior: "smooth", block: "start" });
				}
			}

			showLoading();

			try {
				const queryString = buildQueryString();
				const response = await fetch(`${apiUrl}?${queryString}`);

				if (!response.ok) {
					throw new Error("Failed to fetch posts");
				}

				const data = await response.json();

				if (data.success) {
					updatePostsGrid(data.posts);
					updateResultsCount(data.pagination);
					updatePagination(data.pagination);
				} else {
					throw new Error("API returned an error");
				}
			} catch (error) {
				console.error("Error fetching posts:", error);
				showError("Failed to load posts. Please try again.");
			} finally {
				hideLoading();
			}
		}

		// Update posts grid with new data
		function updatePostsGrid(posts) {
			if (!postsGrid) return;

			if (posts.length === 0) {
				postsGrid.innerHTML =
					'<div class="posts-no-results"><p>No posts found.</p></div>';
				return;
			}

			let html = "";
			posts.forEach((post) => {
				const featuredImage = post.featured_image
					? `<div class="post-card-image">
							<a href="${escapeHtml(post.permalink)}">
								<img src="${escapeHtml(post.featured_image)}" alt="${escapeHtml(post.title)}">
							</a>
						</div>`
					: "";

				html += `
					<article class="post-card">
						${featuredImage}
						<div class="post-card-content">
							<h3 class="post-card-title">
								<a href="${escapeHtml(post.permalink)}">
									${post.title}
								</a>
							</h3>
							<div class="post-card-excerpt">
								${post.excerpt}
							</div>
							<a href="${escapeHtml(post.permalink)}" class="post-card-button">
								Read More
							</a>
						</div>
					</article>
				`;
			});

			postsGrid.innerHTML = html;
			postsGrid.className = `posts-grid posts-grid-columns-${columns}`;
		}

		// Update results count
		function updateResultsCount(pagination) {
			if (!resultsCount) return;

			const showing =
				pagination.current_page * pagination.per_page > pagination.total_posts
					? pagination.total_posts
					: Math.min(
							pagination.current_page * pagination.per_page,
							pagination.total_posts,
						);

			if (currentCountSpan) currentCountSpan.textContent = showing;
			if (totalCountSpan) totalCountSpan.textContent = pagination.total_posts;
		}

		// Update pagination controls
		function updatePagination(pagination) {
			if (!paginationContainer) return;

			const { current_page, total_pages } = pagination;

			// Hide pagination if only one page
			if (total_pages <= 1) {
				paginationContainer.style.display = "none";
				return;
			}

			paginationContainer.style.display = "flex";

			// Build pagination HTML
			let html = `
				<button class="pagination-prev" data-page="${current_page - 1}" ${current_page === 1 ? "disabled" : ""}>Previous</button>
				<div class="pagination-numbers">
			`;

			// Show page numbers
			const maxButtons = 10;
			let startPage = Math.max(1, current_page - Math.floor(maxButtons / 2));
			let endPage = Math.min(total_pages, startPage + maxButtons - 1);

			if (endPage - startPage < maxButtons - 1) {
				startPage = Math.max(1, endPage - maxButtons + 1);
			}

			for (let i = startPage; i <= endPage; i++) {
				const activeClass = i === current_page ? "active" : "";
				html += `<button class="pagination-number ${activeClass}" data-page="${i}">${i}</button>`;
			}

			if (endPage < total_pages) {
				html += '<span class="pagination-ellipsis">...</span>';
			}

			html += `
				</div>
				<button class="pagination-next" data-page="${current_page + 1}" ${current_page === total_pages ? "disabled" : ""}>Next</button>
			`;

			paginationContainer.innerHTML = html;

			// Add event listeners to pagination buttons
			paginationContainer.querySelectorAll("button").forEach((button) => {
				button.addEventListener("click", function () {
					if (this.disabled) return;
					const page = parseInt(this.getAttribute("data-page"), 10);
					currentFilters.page = page;
					fetchPosts(true);
				});
			});
		}

		// Show error message
		function showError(message) {
			if (postsGrid) {
				postsGrid.innerHTML = `<div class="posts-error"><p>${escapeHtml(message)}</p></div>`;
			}
		}

		// Fetch subcategory counts filtered by category
		async function fetchSubcategoryCounts(category) {
			try {
				const url = category
					? `${apiUrl.replace("/posts", "/posts/subcategory-counts")}?category=${encodeURIComponent(category)}`
					: `${apiUrl.replace("/posts", "/posts/subcategory-counts")}`;

				const response = await fetch(url);

				if (!response.ok) {
					throw new Error("Failed to fetch subcategory counts");
				}

				const data = await response.json();

				if (data.success && data.subcategories) {
					return data.subcategories;
				}

				return subcategoriesData; // Fallback to original data
			} catch (error) {
				console.error("Error fetching subcategory counts:", error);
				return subcategoriesData; // Fallback to original data
			}
		}

		// Update subcategory dropdown based on selected category
		async function updateSubcategoryDropdown() {
			if (!subcategorySelect) return;

			if (currentFilters.category) {
				// Enable the dropdown
				subcategorySelect.disabled = false;

				// Fetch updated counts for the selected category
				const updatedSubcategories = await fetchSubcategoryCounts(
					currentFilters.category,
				);

				// Filter and show only options that belong to the selected category
				const allOptions = subcategorySelect.querySelectorAll("option");
				allOptions.forEach((option) => {
					if (option.value === "") {
						// Update placeholder text
						option.textContent = "All Subcategories";
						option.style.display = "";
					} else {
						const categorySlugs = option.getAttribute("data-category-slugs");
						if (
							categorySlugs &&
							categorySlugs.split(",").includes(currentFilters.category)
						) {
							// Find updated count
							const updatedData = updatedSubcategories.find(
								(s) => s.slug === option.value,
							);
							if (updatedData) {
								const subcatName = option.textContent.replace(
									/\s*\(\d+\)$/,
									"",
								);
								option.textContent = `${subcatName} (${updatedData.count})`;
							}
							option.style.display = "";
						} else {
							option.style.display = "none";
						}
					}
				});
			} else {
				// Disable the dropdown and reset to placeholder
				subcategorySelect.disabled = true;
				subcategorySelect.value = "";
				currentFilters.subcategory = "";

				const placeholderOption =
					subcategorySelect.querySelector('option[value=""]');
				if (placeholderOption) {
					placeholderOption.textContent = "Select a category first";
				}
			}
		}

		// Handle category change
		async function handleCategoryChange() {
			if (!categorySelect) return;
			currentFilters.category = categorySelect.value;
			currentFilters.subcategory = "";
			currentFilters.page = 1;
			if (subcategorySelect) subcategorySelect.value = "";
			await updateSubcategoryDropdown();
			updateResetButtonState();
			fetchPosts(false); // Don't scroll on filter change
		}

		// Handle subcategory change
		function handleSubcategoryChange() {
			if (!subcategorySelect) return;
			currentFilters.subcategory = subcategorySelect.value;
			currentFilters.page = 1;
			updateResetButtonState();
			fetchPosts(false); // Don't scroll on filter change
		}

		// Initialize event listeners
		if (categorySelect) {
			categorySelect.addEventListener("change", handleCategoryChange);
		}

		if (subcategorySelect) {
			subcategorySelect.addEventListener("change", handleSubcategoryChange);
		}

		if (resetButton) {
			resetButton.addEventListener("click", resetFilters);
		}

		// Initialize pagination event listeners (for initial load)
		if (paginationContainer) {
			paginationContainer.querySelectorAll("button").forEach((button) => {
				button.addEventListener("click", function () {
					if (this.disabled) return;
					const page = parseInt(this.getAttribute("data-page"), 10);
					currentFilters.page = page;
					fetchPosts(true);
				});
			});
		}

		// Initialize filter states on page load
		function initializeFilters() {
			// Set category dropdown to match selectedCategory attribute
			if (categorySelect) {
				if (selectedCategory) {
					categorySelect.value = selectedCategory;
					currentFilters.category = selectedCategory;
					// Update subcategory dropdown for the selected category
					updateSubcategoryDropdown();
				} else {
					categorySelect.value = "";
					currentFilters.category = "";
				}
			}

			// Ensure subcategory dropdown is in correct initial state
			if (subcategorySelect && !selectedCategory) {
				subcategorySelect.disabled = true;
				subcategorySelect.value = "";
				const placeholderOption =
					subcategorySelect.querySelector('option[value=""]');
				if (placeholderOption) {
					placeholderOption.textContent = "Select a category first";
				}
			}

			// Initialize reset button state
			updateResetButtonState();
		}

		// Run initialization
		initializeFilters();
	});
})();
